import { GraphApproval, GraphApprovalStatus } from "@custom-types/graphs"
import ApprovalStatusIcon from "@features/administration/approvals/ApprovalStatucIcon"
import { format } from "date-fns"
import { MRT_ColumnDef } from "material-react-table"

const readableApprovalStatus = {
  [GraphApprovalStatus.Approved]: "Approved",
  [GraphApprovalStatus.Denied]: "Denied",
  [GraphApprovalStatus.Waiting]: "Pending",
}

export const getApprovalsTableColumns = (): MRT_ColumnDef<GraphApproval>[] => {
  return [
    {
      header: "Graph",
      accessorKey: "graph_key",
      minSize: 350,
    },
    {
      header: "Status",
      accessorFn: ({ approval_status }) => (
        <>
          <ApprovalStatusIcon status={approval_status} sx={{ mr: 1 }} />
          {readableApprovalStatus[approval_status]}
        </>
      ),
    },
    {
      header: "Comments",
      accessorKey: "comments",
    },
    {
      header: "Created",
      accessorKey: "creation_date",
      accessorFn: (approval) => format(new Date(approval.creation_date), "yyyy-MM-dd [HH:mm]"),
    },
    {
      header: "Requested by",
      accessorKey: "creator_email",
    },
  ]
}
